import React from "react";
import { getCurrentCurrency } from "@/utils/countryConfigUtils";

/**
 * 货币单位显示处理
 * 规则：
 * - 服务端返回的货币单位如果是 LOCK_FUN 或者 FUN，统一显示为 FUN COINS
 * - 法币由前端国家配置决定；服务端法币 BRL 显示为当前国家货币
 */
export const formatCurrencyType = (currencyType?: string): string => {
  // FUN 货币单独处理
  if (currencyType === "LOCK_FUN" || currencyType === "FUN") {
    return "FUN COINS";
  }
  
  // 法币统一按当前国家配置显示。
  if (!currencyType || currencyType === "BRL") {
    return getCurrentCurrency();
  }
  
  return currencyType;
};

interface CurrencyDisplayProps {
  currencyType: string;
  className?: string;
}

/**
 * 货币单位展示组件
 */
const CurrencyDisplay: React.FC<CurrencyDisplayProps> = ({
  currencyType,
  className,
}) => {
  return <span className={className}>{formatCurrencyType(currencyType)}</span>;
};

export default CurrencyDisplay;
